import { withHook } from 'utils/withHook';
import { useImageInputState } from 'containers/ImageInput/logic/useImageInputState';
import { ImageInputView } from 'containers/ImageInput/view/ImageInputView';

export const ImageInput = withHook(useImageInputState)(ImageInputView);
